import { render, staticRenderFns } from "./IssueReportDevelopmentNameIssueNo.vue?vue&type=template&id=9d064b60&scoped=true&"
import script from "./IssueReportDevelopmentNameIssueNo.vue?vue&type=script&lang=js&"
export * from "./IssueReportDevelopmentNameIssueNo.vue?vue&type=script&lang=js&"
import style0 from "./IssueReportDevelopmentNameIssueNo.vue?vue&type=style&index=0&id=9d064b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d064b60",
  null
  
)

export default component.exports